import { debounce } from 'throttle-debounce';

export default () => {
    const sidebar = document.querySelector('.sustainability__sidebar-inner');
    const sidebarItems = document.querySelectorAll('.sustainability__sidebar-link');

    if (!sidebar || !sidebarItems) {
        return;
    }

    const handleScroll = () => {
        const sidebarRect = sidebar.getBoundingClientRect();

        sidebarItems.forEach((item) => {
            item.classList.remove('is-active');
        });

        for (let i = sidebarItems.length - 1; i >= 0; i--) {
            const item = sidebarItems[i];
            const targetId = item.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement && targetElement.getBoundingClientRect().top < sidebarRect.top) {
                item.classList.add('is-active');
                break;
            }
        }
    };

    window.addEventListener('scroll', debounce(50, handleScroll));
    handleScroll();
};
